export const MANULIFE_STRINGS_EN = {
  /* Rules templates names */
  MANULIFE_CAMPAIGN_ELIGIBILITY_REWARD_PROGRAM_SEGMENTATION:
    'Reward Program Segmentation',
};
